<template>
  <div class="pre-info">
    <el-form-item label="计价策略:" :label-width="Width">
      <el-select filterable  v-model="form.strategyId" :disabled="form.disabled" placeholder="请选择计价策略">
        <el-option
          v-on:click.native="handleStr(item)"
          v-for="(item, $index) in strategy"
          :key="$index"
          :label="item.strategyName"
          :value="item.strategyId"  >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="计价规则:" :label-width="Width">
      <el-select filterable v-model="form.rule"  :disabled="form.disabled" placeholder="请选择计价规则">
        <el-option
          v-for="(item, $index) in priciRule"
          :key="$index"
          :label="item.ruleNameCn"
          :value="item.ruleId" v-on:click.native="handleRule(item)" >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="规则生效时间:" :label-width="Width">
      <el-date-picker
        type="datetime"
        v-model="form.date"
        placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" :disabled="form.disabled">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="计价字段:" :label-width="Width" v-for="(item, $index) in billArr" :key="$index">
      <el-input style="width: 217px;" placeholder="请输入$.resp.计价字段" :disabled="form.disabled" v-model="item.billKeyWord"></el-input>
      <el-input style="width: 217px;" :disabled="form.disabled" class="ml" v-model="item.billParamName"></el-input>
    </el-form-item>
    <el-button type="primary" v-show="add" class="add-info" icon="el-icon-plus" @click="addBill"></el-button>
    <el-button type="primary" v-show="!add" class="add-info" icon="el-icon-minus" @click="reduceBill"></el-button>
  </div>
</template>
<style>
.ul li {
  list-style: none;
}
.add-info {
  position: absolute;
  top: 0px;
  left: 350px;
}
.info-title {
  font-weight: bolder;
}
.pre-info {
  position: relative;
}
.ml {
  margin-left: 10px;
}
</style>
<script>
export default {
  props: ['strategy', 'form', 'priciRule', 'billArr', 'add'],
  data () {
    return {
      value14: '',
      pickerBeginDateBefore: {
        disabledDate (time) {
          let yestoday = new Date()
          yestoday.setDate(yestoday.getDate() - 1)
          return time.getTime() < yestoday.getTime()
        }
      },
      Width: '120px'
    }
  },
  methods: {
    handleStr (item) {
      this.$emit('switchStr', item)
    },
    changeTime () {
      // var startTime = new Date(this.form.date) * 1000 / 1000
      // if (startTime < Date.now()) {
      //   this.form.date = new Date()
      // }
    },
    handleRule (item) {
      this.$emit('switchRule', item)
    },
    addBill () {
      this.$emit('addBill')
    },
    reduceBill () {
      this.$emit('reduceBill')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/supper/rule/Rule.vue